import { AnalysisBlockProps, AnalysisResultBlockProps } from '@/pages/ExperienceProjectDetailPage/components/AnalysisFlowView/AnalysisBlock/AnalysisBlock'
import { useEffect, useState } from 'react'
import useI18nFlowAnalysisTips from './useFlowAnalysisTips'
import { useTranslation } from 'react-i18next'


interface RangeResult {
  range: [number, number]
  flowDescs: Array<AnalysisBlockProps | AnalysisResultBlockProps>
  module: 'heatmap' | 'subjectiveResponseCurve' | 'indexAnalysis' | 'consumerAttitudeAnalysis' | 'fiveDimension' | 'result'
  descs: AnalysisBlockProps[]
}

function getRangeResults(rangeResults: RangeResult[], percent: number) {
  return rangeResults.map(range => {
    const start = range.range[0]
    const end = range.range[1]
    if (end <= percent) {
      return {
        ...range,
        flowDescs: range.descs
      }
    } else if (start > percent) {
      return range
    } else {
      const length = range.descs.reduce((acc, curr) => {
        return acc + curr.content.length + 1
      }, 0)
      const ticker = Math.floor((end - start) / length)
      let flag = 0
      const newTips: AnalysisBlockProps[] = range.descs.map(tip => {
        flag++
        const status: AnalysisBlockProps['status'] = flag * ticker + start > percent ? 'pending' : 'completed'
        if ((status === 'completed' && tip.content.length === 0) || status === 'pending') {
          return { ...tip, status, content: [] }
        } else {
          const newContent = tip.content.map(content => {
            flag++
            const contentStatus: AnalysisBlockProps['status'] = flag * ticker + start > percent ? 'pending' : 'completed'
            return { ...content, status: contentStatus }
          })
          const contentHasPending = newContent.some(item => item.status === 'pending')
          return { ...tip, status: contentHasPending ? 'pending' : 'completed', content: newContent }
        }
      })
      const pendingIndex = newTips.findIndex(item => item.status === 'pending')
      let newFlowDescs: AnalysisBlockProps[] = []
      if (pendingIndex !== -1) {
        newFlowDescs = newTips.slice(0, pendingIndex + 1).map((tip) => {
          const contentPendingIndex = tip.content.findIndex(item => item.status === 'pending')
          let _content: AnalysisBlockProps['content'] = []
          if (contentPendingIndex !== -1) {
            _content = tip.content.slice(0, contentPendingIndex + 1)
          } else {
            _content = []
          }
          return { ...tip, content: _content }
        })
      } else {
        newFlowDescs = newTips
      }
      return {
        ...range,
        flowDescs: newFlowDescs
      }
    }

  })
}


function useFlowAnalysisResult(percent: number) {
  const [currentRangeResult, setCurrentRangeResult] = useState<RangeResult[]>([])
  const { i18n } = useTranslation()
  const { HEATMAP_TIPS, SUBJECTIVE_RESPONSE_CURVE_TIPS, INDEX_ANALYSES_TIPS, CONSUMER_ATTITUDE_ANALYSIS_TIPS, FIVE_DEMENSION_BENEFITS_TIPS } = useI18nFlowAnalysisTips()
  const RANGE_RESULTS: RangeResult[] = [
    { range: [0, 15], flowDescs: [], module: 'heatmap', descs: HEATMAP_TIPS, },
    { range: [15, 75], flowDescs: [], module: 'subjectiveResponseCurve', descs: SUBJECTIVE_RESPONSE_CURVE_TIPS, },
    { range: [75, 85], flowDescs: [], module: 'indexAnalysis', descs: INDEX_ANALYSES_TIPS, },
    { range: [85, 85], flowDescs: [], module: 'consumerAttitudeAnalysis', descs: CONSUMER_ATTITUDE_ANALYSIS_TIPS, },
    { range: [85, 85], flowDescs: [], module: 'fiveDimension', descs: FIVE_DEMENSION_BENEFITS_TIPS },
  ]

  useEffect(() => {
    const rangeResults = getRangeResults(RANGE_RESULTS, percent)
    // console.log(rangeResults)
    setCurrentRangeResult(rangeResults)
  }, [percent, i18n.language])

  return currentRangeResult
}

export default useFlowAnalysisResult